<app-display-indicator></app-display-indicator>
<ng-container [ngSwitch]="infoTableElement$ | async">
  <!---Station display data-->
  <app-station-track *ngSwitchCase="trackStatus.DISPLAY" [realizationResponse]="data" [notifications]="notifications"></app-station-track>
  <!---Out of order--->
  <app-out-of-order *ngSwitchCase="trackStatus.OUT_OF_ORDER"></app-out-of-order>
</ng-container>
<div id="enetel-solutions">Powered by Enetel Solutions</div>
